"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleRouterSync = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var utils_1 = require("./utils");
/**
 * Example usage of `ModuleRouterSync` and `addModuleRouter` to integrate module-specific routing within a larger application.
 * This setup demonstrates how to wrap your components with `ModuleRouterSync` to ensure they are part of the module routing synchronization process.
 * Additionally, it shows how to register a router created with `createBrowserRouter` to the global `moduleRouters` array for synchronization across different modules.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { createBrowserRouter } from 'react-router-dom';
 * import { ModuleRouterSync, addModuleRouter } from './ModuleRouterSync';
 * import PersonalData from './PersonalData';
 *
 * // Create a browser router with specific routes for this module
 * const router = createBrowserRouter([
 *   {
 *     path: `/user/profile`,
 *     element: <ModuleRouterSync><PersonalData /></ModuleRouterSync>, // Wrap the component with ModuleRouterSync
 *   },
 *   {
 *     path: '*',
 *     element: <ModuleRouterSync/> // Default catch-all route wrapped in ModuleRouterSync for consistency
 *   },
 * ]);
 *
 * // Register the created router to enable synchronization with other module routers
 * addModuleRouter(router);
 * ```
 *
 * The `ModuleRouterSync` component wraps the `PersonalData` component (or any other component you wish to include in the module router)
 * to ensure that navigation within this module is synchronized with other module routers in the application.
 * All paths within the module should be wrapped with `ModuleRouterSync` to ensure that the module router is aware of the navigation changes.
 *
 * This setup needs to be done the same way for each module that requires its own routing including the host application.
 */
var ModuleRouterSync = function (_a) {
    var children = _a.children;
    (0, utils_1.useModuleRouterSync)();
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
};
exports.ModuleRouterSync = ModuleRouterSync;
